export const UNKNOWN_PIC = 'AAAAAAAA';
export const UNKNOWN_PIC_DESTINATION = 'EEEEEEEE';

export const MOBILE_OR_TABLET_WIDTH = 768;
export const DESKTOP_WIDTH = 1024;

export const FILE_REGEX = /file:[a-zA-Z_]+\.(jpg|jpeg|png);/;
export const BLANK_IMAGE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAAC0lEQVR42mNkAAIAAAoAAv/lxKUAAAAASUVORK5CYII=';

export const ACCEPTED_FILE_EXTENSIONS_IMAGES = '.jpg, .jpeg, .png';
export const ACCEPTED_FILE_EXTENSIONS = '.jpg, .jpeg, .png, .pdf, .heic, .heif';
export const ACCEPTED_IMAGE_EXTENSION_LABEL = 'JPG, PNG';
export const ONE_MB_BYTES = 1 * 1024 * 1024;
export const ACCEPTED_FILE_EXTENSION_LABEL = 'JPG, PDF, PNG or HEIC';
export const ACCEPTED_MIMETYPES_IMAGES = ['image/jpg', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'];
export const ACCEPTED_MIMETYPES_FILES = ['application/pdf'];
export const ACCEPTED_MIMETYPES = [...ACCEPTED_MIMETYPES_FILES, ...ACCEPTED_MIMETYPES_IMAGES];
export const ACCEPTED_FILESIZE = 5;

export const REGISTRATION_PATH = '/register';
export const WELCOME_PATH = '/';
export const ALLOWED_NEW_USER_PATHS = [REGISTRATION_PATH, WELCOME_PATH];
export const PHONE_REGEX = new RegExp('^(?:\\+?61|0)[2-478](?:[ -]?[0-9]){8}$');
export const EDITABLE_AND_DELETABLE_IDS_V4 = ['1', '157'];
export const HELPDESK_NUMBER = '1800 683 111';
export const FETCH_USER_DETAILS_ERROR_MSG = `Oops! It seems that something isn't quite right, but rest assured, we're working on fixing it. Please try again later or call ISC Helpdesk at ${HELPDESK_NUMBER}.`;
export const TRANSPORTER_EMAIL_QUESTION_ID = '182';
export const TRANSPORTER_QUESTION_TEXT = 'Transporter';
export const INVALID_PHONE_NUMBER = 'Please enter a valid phone number (e.g. 0299999999 or +61400000000)';
export const INVALID_POSTCODE = 'Please enter valid 4 digit Postcode';
export const CONSIGNMENT_SUBMITTED_TITLE = 'This consignment has been submitted';
export const CONSIGNMENT_SUBMITTED_MESAGE =
    'The creator of this consignment can still change the movement date, livestock description and transporter details until 7 days after movement date and time.';
export const CONSIGNMENT_COMMENT_DIALOG_MESSAGE = 'Once a comment is added, it cannot be edited or deleted.';
export const COMMENT_MAXLENGTH = 256;
// Movement-page free-text limits. These mirror the API's own per-field maximums exactly, as
// boundary-tested by the ENVDB-6401 spike. Input is not capped at these values — a longer value can
// be typed or pasted, and UserEdit then reports it and blocks Apply until it is trimmed.
export const PERSON_NAME_MAXLENGTH = 300;
export const PERSON_ADDRESS_MAXLENGTH = 300;
export const PERSON_TOWN_MAXLENGTH = 100;
// The cap every static string question has carried since 2020. Named rather than inlined so the
// follow-up that makes static limits validator-driven has one place to change. Do NOT raise this
// without resolving the per-form limit anomalies (ENVDB-6401 open question 4).
export const STATIC_STRING_DEFAULT_MAXLENGTH = 100;
export const NOTEDITABLE_WHEN_DECLARETICKED_IDS = ['158'];
export const TRANSPORTER_DECLARED_BOX_QUESTION_ID = '164';
export const REQUIRED_WHEN_VALIDATOR_TYPE = 'requiredWhen';
export const UNIQUE_WHEN_VALIDATOR_TYPE = 'unique';
export const COMBO_PARAMETERS: any = { '158': 'email', '159': 'rego' };
export const TRANSPORTER_DELETION_ERROR_CODE = '1015';
export const CSV_FILE_TYPE = 'text/csv';
export const TXT_FILE_TYPE = 'text/plain';
export const MAX_UPLOAD_DEVICES = 10000;
export const HOW_TO_GUIDE_MOVEMENT_LINK =
    'https://www.integritysystems.com.au/globalassets/isc/pdf-files/integration-guide.pdf';
export const TERMS_OF_USE_LINK =
    'https://www.integritysystems.com.au/on-farm-assurance/national-vendor-declaration-nvd/envd-app/terms-of-use/';
export const ABOUT_ENVD = 'https://www.integritysystems.com.au/on-farm-assurance/national-vendor-declaration-nvd/';
export const TERMS_AND_CONDITIONS = 'https://www.integritysystems.com.au/terms-and-conditions/';
export const PRIVACY_POLICY = 'https://www.integritysystems.com.au/privacy-website/';
export const ENVD_HOW_TO_GUIDE =
    'https://www.integritysystems.com.au/on-farm-assurance/how-to-guides/how-to-create-a-new-mymla-account-and-link-your-integrity-system-accounts/';
// Render-only question type (ENVDB-8768): `text` = title, `help` = markdown body, collects no answer.
// Kept as a constant because IDynamicQuestion.type resolves to `any`, so the generated union cannot catch a misspelt literal.
export const RICH_TEXT_QUESTION_TYPE = 'RICH_TEXT';

// Copy for the unlock/lock change-alerts heading and its help modal (ENVDB-6902 AC4). Both are
// markdown, rendered by FormRow via ReactMarkdown; the label doubles as the modal title.
export const UNLOCK_SECTION_LABEL = '**NEW:** Change alerts (unlock/lock)';
export const UNLOCK_INFO_HELP = `**What does UNLOCK mean?**

Once a consignment is lodged, the details are set (SUBMITTED & LOCKED).

If your receiver needs to fix something, they can open it up for edits; you will see it marked with an UNLOCKED status in your consignment list. You will have 24 hours before it is LOCKED again automatically.

**To make sure you are aware of these changes, you can be notified via EMAIL and/or SMS.**`;

// Opt-out warning copy (ENVDB-6902 AC4). The daily-summary email has its own PIC-specific message;
// the lock/unlock email and SMS options share the consignment-changes message.
export const OPT_OUT_WARNING_DAILY_SUMMARY =
    "If you opt-out of this notification type, you will not be notified when eNVD's are addressed to your PIC number";
export const OPT_OUT_WARNING_UNLOCK =
    'If you opt out of this notification type, you will not be notified when changes are made to your consignments. You can re-enable this at any time in your account settings.';

// Field names of the user notification-preference flags. These match the keys on IUserProfileFields and
// the user claims/GraphQL schema, so they must not be renamed independently of those.
export const NOTIFICATION_PREFERENCE_FIELDS = {
    RECEIVE_EMAILS: 'receiveEmails',
    RECEIVE_UNLOCK_EMAIL: 'receiveUnlockEmail',
    RECEIVE_UNLOCK_SMS: 'receiveUnlockSms',
} as const;

export type NotificationPreferenceField =
    (typeof NOTIFICATION_PREFERENCE_FIELDS)[keyof typeof NOTIFICATION_PREFERENCE_FIELDS];
